module.exports = __webpack_public_path__ + "static/media/Minion3-Regular.cc66c722.svg";